import getQuerySearchSelect from 'modules/search/selectors/get-query'
import getDomainListPathFromQueryReduxUtil from 'modules/redux/utils/get-domain-list-path-from-query'
import {
  getDataPathReduxUtil,
  WORKOUTS_PATH
} from '@gymaholic/packages'
import { getObjectUtil } from 'packages/src'

const getRecommendedDomainListDataWorkoutSelect = state => {
  const query = getQuerySearchSelect(state)
  const path = getDomainListPathFromQueryReduxUtil(WORKOUTS_PATH.RECOMMENDED, query)
  const dataPath = getDataPathReduxUtil(path)
  return getObjectUtil(state, dataPath)
}

export default getRecommendedDomainListDataWorkoutSelect
